const getters = {
  filters: function(state) {
    return state.filters
  },

  sort: function(state) {
    return state.sort
  },

  page: function(state) {
    return state.page
  },

  limit: function(state) {
    return state.limit
  },
}

export default getters
